"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiPortalContent = exports.UiPortal = exports.UiPortalsProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var PortalContext = react_1.default.createContext(null);
var UiPortalsProvider = function (_a) {
    var children = _a.children;
    var portals = react_1.default.useState(function () { return (0, mobx_1.observable)({}, {}, { deep: false }); })[0];
    return ((0, jsx_runtime_1.jsx)(PortalContext.Provider, __assign({ value: portals }, { children: children })));
};
exports.UiPortalsProvider = UiPortalsProvider;
exports.UiPortal = (0, mobx_react_1.observer)(function (_a) {
    var name = _a.name, children = _a.children;
    var portals = react_1.default.useContext(PortalContext);
    return (0, mobx_1.get)(portals, name) || children || null;
});
var UiPortalContent = function (_a) {
    var name = _a.name, children = _a.children;
    var portals = react_1.default.useContext(PortalContext);
    react_1.default.useEffect(function () {
        if ((0, mobx_1.get)(portals, name)) {
            throw new Error("Content for portal with name ".concat(name, " is already set"));
        }
        (0, mobx_1.set)(portals, name, children);
        return function () {
            (0, mobx_1.set)(portals, name, null);
        };
    }, [children, portals, name]);
    return null;
};
exports.UiPortalContent = UiPortalContent;
